import { PageTypeId } from '../const';
import { NavigationTitleCodes } from '../types';
import { navigationCodes } from '../../../data/translations/navigationCodes';
import { PUBLIC_CUSTOM_PAGE_PATH } from '../../../utils/const';

export const defaultNavigationTitleCodes: NavigationTitleCodes = {
	[PageTypeId.Home]: navigationCodes.home,
	[PageTypeId.Dashboard]: navigationCodes.dashboard,
	[PageTypeId.UserList]: navigationCodes.userList,
	[PageTypeId.ManagementInformation]: navigationCodes.managementInformation,
	[PageTypeId.AgencyList]: navigationCodes.agencyList,
	[PageTypeId.AgencyStructure]: navigationCodes.agencyStructure,
	[PageTypeId.ActivityList]: navigationCodes.activityList,
	[PageTypeId.AutomationList]: navigationCodes.automationList,
	[PageTypeId.AutomationLogList]: navigationCodes.automationLogList,
	[PageTypeId.CalculationSchemeList]: navigationCodes.calculationSchemeList,
	[PageTypeId.CandidatePeriodicComponentsList]: navigationCodes.candidatePeriodicComponentsList,
	[PageTypeId.CandidatePhaseList]: navigationCodes.candidatePhaseList,
	[PageTypeId.CandidateReservationList]: navigationCodes.candidateReservationList,
	[PageTypeId.CandidateList]: navigationCodes.candidateList,
	[PageTypeId.CandidateChangeList]: navigationCodes.candidateChangeList,
	[PageTypeId.CandidateCandidateStatusMapping]: navigationCodes.candidateCandidateStatusMapping,
	[PageTypeId.CaoNewsList]: navigationCodes.caowijzerCaoNewsList,
	[PageTypeId.CaoList]: navigationCodes.caowijzerCaoList,
	[PageTypeId.CaoInstanceList]: navigationCodes.caowijzerCaoInstanceList,
	[PageTypeId.CaoWagesList]: navigationCodes.caowijzerCaoWagesList,
	[PageTypeId.CaoWagesRequestsList]: navigationCodes.caowijzerCaoWagesRequestsList,
	[PageTypeId.CaoWmlList]: navigationCodes.caowijzerWmlList,
	[PageTypeId.CommentList]: navigationCodes.commentList,
	[PageTypeId.CommunitiesList]: navigationCodes.communitiesList,
	[PageTypeId.ComponentModelList]: navigationCodes.componentModelList,
	[PageTypeId.ConnectorList]: navigationCodes.connectorList,
	[PageTypeId.ContractList]: navigationCodes.contractList,
	[PageTypeId.ContractBulkUpdateRequestList]: navigationCodes.contractBulkUpdateRequestList,
	[PageTypeId.DealList]: navigationCodes.dealList,
	[PageTypeId.DocumentTemplateList]: navigationCodes.documentTemplateList,
	[PageTypeId.DocumentList]: navigationCodes.documentList,
	[PageTypeId.DocumentSettingsList]: navigationCodes.documentSettingsList,
	[PageTypeId.EmployerContactPersonsList]: navigationCodes.employerContactPersonsList,
	[PageTypeId.EmployerList]: navigationCodes.employerList,
	[PageTypeId.FlexNetCustomerList]: navigationCodes.flexNetCustomerList,
	[PageTypeId.FlexNetHostList]: navigationCodes.flexNetHostList,
	[PageTypeId.FlexNetHostSettings]: navigationCodes.flexNetHostSettings,
	[PageTypeId.FormUserList]: navigationCodes.formUserList,
	[PageTypeId.IllnessList]: navigationCodes.illnessList,
	[PageTypeId.InvoiceList]: navigationCodes.invoiceList,
	[PageTypeId.InvoicePurchaseInvoice]: navigationCodes.invoicePurchaseInvoice,
	[PageTypeId.JobList]: navigationCodes.jobJobList,
	[PageTypeId.LabelList]: navigationCodes.labelLabelList,
	[PageTypeId.LabelPagesList]: navigationCodes.labelPagesList,
	[PageTypeId.LabelTemplates]: navigationCodes.labelTemplates,
	[PageTypeId.LabelTranslations]: navigationCodes.labelTranslations,
	[PageTypeId.ModelMatrixInstanceList]: navigationCodes.modelMatrixInstanceList,
	[PageTypeId.ModelMatrixList]: navigationCodes.modelMatrixList,
	[PageTypeId.NewsAdminList]: navigationCodes.newsList,
	[PageTypeId.NewsList]: navigationCodes.newsList,
	[PageTypeId.PaymentList]: navigationCodes.paymentList,
	[PageTypeId.PayslipList]: navigationCodes.payslipList,
	[PageTypeId.PensionList]: navigationCodes.pensionList,
	[PageTypeId.ProformaList]: navigationCodes.proformaList,
	[PageTypeId.RateClassesList]: navigationCodes.rateClassesList,
	[PageTypeId.RoleList]: navigationCodes.roleList,
	[PageTypeId.SavedFilterAlertLogsList]: navigationCodes.savedFilterAlertLogsList,
	[PageTypeId.SavedFilterMyFiltersList]: navigationCodes.savedFilterMyFiltersList,
	[PageTypeId.SavedFilterOtherUsersFiltersList]: navigationCodes.savedFilterOtherUsersFiltersList,
	[PageTypeId.SavedFilterSystemFiltersList]: navigationCodes.savedFilterSystemFiltersList,
	[PageTypeId.ShareJobBoardInstanceList]: navigationCodes.shareJobboardInstanceList,
	[PageTypeId.ShareJobBoardList]: navigationCodes.shareJobboardList,
	[PageTypeId.ShareJobPostList]: navigationCodes.shareJobpostList,
	[PageTypeId.ShareLogList]: navigationCodes.shareSharelogList,
	[PageTypeId.SubscriberList]: navigationCodes.subscriberSubscriberList,
	[PageTypeId.SurveyList]: navigationCodes.surveyList,
	[PageTypeId.TagList]: navigationCodes.tagList,
	[PageTypeId.TaskList]: navigationCodes.taskList,
	[PageTypeId.TextModelList]: navigationCodes.textModelList,
	[PageTypeId.TimecardList]: navigationCodes.timecardList,
	[PageTypeId.SupplierOrganizationList]: navigationCodes.supplierOrganizationList,
	[PageTypeId.BackofficeIndex]: navigationCodes.backofficeIndex,
	[PageTypeId.BackofficeProcessingList]: navigationCodes.backofficeProcessinglist,
	[PageTypeId.BackofficeJournalTransferFilesList]: navigationCodes.backofficeJournalTransferFilesList,
	[PageTypeId.BackofficePaymentTransferFilesList]: navigationCodes.backofficePaymentTransferFilesList,
	[PageTypeId.ConnectIncomingList]: navigationCodes.connectIncomingList,
	[PageTypeId.ConnectIncomingLogList]: navigationCodes.connectIncomingLogList,
	[PageTypeId.ConnectOutgoingList]: navigationCodes.connectOutgoingList,
	[PageTypeId.ConnectOutgoingLogList]: navigationCodes.connectOutgoingLogList,
	[PageTypeId.ConnectSettings]: navigationCodes.connectSettings,
	[PageTypeId.ConnectEmailSenderAuthList]: navigationCodes.connectEmailSenderauthList,
	[PageTypeId.ConnectApiUserList]: navigationCodes.connectApiUserList,
	[PageTypeId.ConnectCustomerAccessRequestList]: navigationCodes.connectCustomerAccessRequestList,
	[PageTypeId.ConnectFSApiLogList]: navigationCodes.connectFsApiLogList,
	[PageTypeId.ConnectDashboard]: navigationCodes.connectDashboard,
	[PageTypeId.ApplicationList]: navigationCodes.applicationList,
	[PageTypeId.ApplicationForm]: navigationCodes.applicationForm,
	[PageTypeId.CustomerList]: navigationCodes.customerCustomerList,
	[PageTypeId.InvoiceComponentsList]: navigationCodes.invoiceComponentsList,
	[PageTypeId.CustomerInvoiceList]: navigationCodes.customerInvoiceList,
	[PageTypeId.CustomerSubscriptionList]: navigationCodes.customerSubscriptionList,
	[PageTypeId.CustomerSubscriptionSettingList]: navigationCodes.customerSubscriptionSettingList,
	[PageTypeId.SafetyList]: navigationCodes.safetyList,
	[PageTypeId.DomainValuesList]: navigationCodes.domainValuesList,
	[PageTypeId.DomainValuesMapping]: navigationCodes.domainValuesMapping,
	[PageTypeId.DomainValuesCAOMapping]: navigationCodes.domainValuesCaoMapping,
	[PageTypeId.CustomCaoList]: navigationCodes.caowijzerCustomCaoList,
	[PageTypeId.CustomCaoInstanceList]: navigationCodes.caowijzerCustomCaoInstanceList,
	[PageTypeId.AuditTrailList]: navigationCodes.auditTrailList,
	[PageTypeId.SettingList]: navigationCodes.settingList,
	[PageTypeId.SurveyAdminList]: navigationCodes.surveySurveyAdminList,
	[PageTypeId.SurveyListOptOutList]: navigationCodes.surveyListOptOutList,
	[PageTypeId.Faq]: navigationCodes.learnings,
	[PageTypeId.Help]: navigationCodes.help,
	[PageTypeId.AboutUs]: navigationCodes.aboutUs,
	[PageTypeId.ContactUs]: navigationCodes.contactUs,
	[PageTypeId.PrivacyStatement]: navigationCodes.privacyStatement,
	[PageTypeId.CvdPolicy]: navigationCodes.cvdPolicy,
	[PageTypeId.SecurityStatement]: navigationCodes.securityStatement,
	[PageTypeId.TermsOfUse]: navigationCodes.termsOfUse,
};
